import moment from 'moment';

export const FROM_INIT_VALUE = moment().utc().startOf('month');
export const TO_INIT_VALUE = moment().utc().endOf('month');
